import { createContext, useContext, type PropsWithChildren } from "react";
import { ApolloProvider, type ApolloClient } from "@apollo/client";
import type { ShellHandleHost } from "./createShellHandle";

const ShellHostContext = createContext<ShellHandleHost | null>(null);
const CloudClientContext = createContext<ApolloClient<unknown> | null>(null);

export interface ShellHostProviderProps {
  host: ShellHandleHost;
  client: ApolloClient<unknown>;
  cloudClient?: ApolloClient<unknown>;
}

export function ShellHostProvider({
  host,
  client,
  cloudClient,
  children,
}: PropsWithChildren<ShellHostProviderProps>) {
  return (
    <ApolloProvider client={client}>
      <CloudClientContext.Provider value={cloudClient ?? null}>
        <ShellHostContext.Provider value={host}>
          {children}
        </ShellHostContext.Provider>
      </CloudClientContext.Provider>
    </ApolloProvider>
  );
}

export function useCloudClient(): ApolloClient<unknown> | null {
  return useContext(CloudClientContext);
}

export function useShellHost(): ShellHandleHost {
  const v = useContext(ShellHostContext);
  if (!v)
    throw new Error("useShellHost must be used within <ShellHostProvider>");
  return v;
}
